import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { getRouteByName, isHttp, routePathToName, toRoutePath } from '@/common/utils/common'
import { existsToken } from '@/common/utils/token'
import { useUserStore } from '@/stores/user'
import { useCommonStore } from '@/stores/common'
import { useTabStore } from '@/stores/tab'
import qs from 'qs'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { SettingCodeEnum } from '@/common/enums/system.ts'

export const staticLayoutRoutes: RouteRecordRaw[] = [
    {
        name: routePathToName('/global/file/index'),
        path: toRoutePath('/global/file/index'),
        component: () => import('@/views/global/file/index.vue'),
        meta: {
            title: '文件管理',
        },
    },
    {
        name: routePathToName('/system/error/403'),
        path: toRoutePath('/system/error/403'),
        component: () => import('@/views/system/error/404.vue'),
        meta: {
            title: '403',
            icon: 'el-icon-error',
            roles: ['admin', 'employee'],
        },
    },
    {
        name: routePathToName('/system/error/404'),
        path: toRoutePath('/system/error/404'),
        component: () => import('@/views/system/error/404.vue'),
        meta: {
            title: '404',
            icon: 'el-icon-error',
            roles: ['admin', 'employee'],
        },
    },
    {
        name: routePathToName('/system/error/500'),
        path: toRoutePath('/system/error/500'),
        component: () => import('@/views/system/error/404.vue'),
        meta: {
            title: '500',
            icon: 'el-icon-error',
            roles: ['admin', 'employee'],
        },
    },
]

export const layoutRoute: RouteRecordRaw = {
    path: import.meta.env.VITE_SERVER_CONTEXT || '',
    component: () => import('@/layout/index.vue'),
    children: staticLayoutRoutes,
    redirect: toRoutePath('/office/workbench/index'),
}

export const staticRoutes: RouteRecordRaw[] = [
    {
        name: 'index',
        path: '/',
        redirect: toRoutePath('/index'),
    },
    {
        name: 'index2',
        path: '/index',
        redirect: toRoutePath('/office/workbench/index'),
    },
    {
        name: routePathToName('/system/employee/login'),
        path: toRoutePath('/system/employee/login'),
        component: () => import('@/views/system/employee/login.vue'),
    },
    {
        name: routePathToName('/error/403'),
        path: toRoutePath('/error/403'),
        component: () => import('@/views/error/403.vue'),
    },
    {
        name: routePathToName('/error/404'),
        path: toRoutePath('/error/404'),
        component: () => import('@/views/error/404.vue'),
    },
    {
        name: routePathToName('/error/500'),
        path: toRoutePath('/error/500'),
        component: () => import('@/views/error/500.vue'),
    },
]

const routes = [layoutRoute, ...staticRoutes]

const router = createRouter({
    history: createWebHashHistory(import.meta.env.VITE_SERVER_CONTEXT || ''),
    // history: createWebHistory(import.meta.env.VITE_SERVER_CONTEXT || ''),
    routes: routes,
    scrollBehavior() {
        return { top: 0, left: 0 }
    },
})

// 免登录页面
const singleNoLoginRouteNameList: string[] = [
    routePathToName('/system/employee/login'),
    routePathToName('/error/403'),
    routePathToName('/error/404'),
    routePathToName('/error/500'),
]

// 独立页面
const singleRouteNameList: string[] = [
    routePathToName('/error/403'),
    routePathToName('/error/404'),
    routePathToName('/error/500'),
]

NProgress.configure({
    easing: 'ease', // 动画方式，和css动画属性一样（默认：ease）
    speed: 500, // 递增进度条的速度，单位ms（默认： 200）
    showSpinner: false, // 是否显示加载ico
    trickle: true, //是否自动递增
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3, // 初始化时的最小百分比，0-1（默认：0.08）
    // parent: '#container'//指定此选项以更改父容器（默认：body）
})

// 是否刷新整个页面
let isForceRefresh = true
router.beforeEach(async (to, from, next) => {
    console.log('enterRoute', to, from)
    NProgress.start()
    if (singleRouteNameList.includes(to.name as unknown as string)) {
        console.log('errorRoute')
        next()
        return
    }

    const commonStore = useCommonStore()
    const userStore = useUserStore()
    const tabStore = useTabStore()

    if (isForceRefresh) {
        // 刷新整个页面
        await commonStore.setPageGlobalIsLoading(true)
        try {
            await commonStore.getBaseSetting(true)
        } catch (error) {
            console.log('forceRefreshError')
            isForceRefresh = false
            next({ name: routePathToName('/error/500') })
            return
        }
        document.title = commonStore.setting?.[SettingCodeEnum.WEBSITE_TITLE]?.value || ''
        if (existsToken()) {
            try {
                await userStore.getCurrent()
                await tabStore.setTabList([])
            } catch (error) {
                console.log('existsTokenRoute')
                isForceRefresh = false
                next({ name: routePathToName('/error/500') })
                return
            }
            console.log('existsTokenRoute2')
            isForceRefresh = false
            if (singleNoLoginRouteNameList.includes(to.name as unknown as string)) {
               next({ name: routePathToName('/') })
                return
            }
            next({ ...to })
            return
        } else {
            if (singleNoLoginRouteNameList.includes(to.name as unknown as string)) {
                console.log('forceRefreshWhiteRoute')
                isForceRefresh = false
                if (to.name === routePathToName('/system/employee/login')) {
                    console.log('clear3')
                    sessionStorage.clear()
                    localStorage.clear()
                    next()
                    return
                }
            } else {
                console.log('forceRefreshRedirectLogin')
                isForceRefresh = false
                console.log('clear2')
                sessionStorage.clear()
                localStorage.clear()
                next({
                    name: routePathToName('/system/employee/login'),
                    replace: true,
                })
                return
            }
        }
    } else {
        console.log('noForceRefresh')
        // 非刷新整个页面
        await commonStore.setLayoutRouteIsLoading(true)
        if (!commonStore.settingIsCached) {
            try {
                await commonStore.getBaseSetting()
            } catch (error) {
                console.log('noForceRefreshError')
                next({ name: routePathToName('/error/500') })
                return
            }
        }
        document.title = commonStore.setting?.[SettingCodeEnum.WEBSITE_TITLE]?.value || ''
        if (existsToken()) {
            console.log('?????here')
            if (!userStore.userIsCached) {
                try {
                    await userStore.getCurrent()
                } catch (error) {
                    console.log('noForceExistsTokenRefreshError')
                    next({ name: routePathToName('/error/500') })
                    return
                }
            }
            if (to.name === routePathToName('/system/employee/login')) {
                console.log('clear11111')
                sessionStorage.clear()
                localStorage.clear()
                next()
                return
            }
        } else {
            if (singleNoLoginRouteNameList.includes(to.name as unknown as string)) {
                console.log('forceRefreshWhiteRoute')
                console.log('to.name', to.name)
                if (to.name === routePathToName('/system/employee/login')) {
                    console.log('clear1')
                    sessionStorage.clear()
                    localStorage.clear()
                }
            } else {
                console.log('noForceRefreshRedirectLogin')
                console.log('clear4')
                sessionStorage.clear()
                localStorage.clear()
                next({
                    name: routePathToName('/system/employee/login'),
                    replace: true,
                })
                return
            }
        }
    }

    let isMatch = tabStore.tabList.filter(tab => tab.key === to.name).length > 0
    console.log('isMatch: ', isMatch)
    if (!isMatch) {
        const route = getRouteByName(router.getRoutes(), to.name as unknown as string)
        if (route) {
            isMatch = true
            await tabStore.addTab(
                {
                    key: to.name as string,
                    title: to.meta.title as string,
                    path: to.fullPath as string,
                    query: to.query,
                    componentPath: to.path as string,
                    isOpenNewWindow: isHttp(to.path),
                },
                false,
            )
        }
    }
    if (isMatch) {
        console.log('1')
        tabStore.setActiveKey(to.name)
        next()
        return
    } else {
        if (to.name) {
            await tabStore.addTab(
                {
                    key: to.name as string,
                    title: to.meta.title as string,
                    path: to.fullPath as string,
                    query: to.query,
                    componentPath: to.path as string,
                    isOpenNewWindow: isHttp(to.path),
                },
                true,
            )
            console.log('2')
            next()
            return
        } else {
            const routeRecord = router.getRoutes().find(route => {
                if (to.query) {
                    return route.path === to.path + '?' + qs.stringify(to.query)
                }
                return route.path === to.path
            })
            if (routeRecord) {
                console.log('replaceRoute')
                await router.replace({
                    name: routeRecord.name,
                    query: from?.query,
                })
                return
            } else {
                console.log('redirectError404')
                next({ name: routePathToName('/error/404'), replace: true })
                return
            }
        }
    }
})

router.afterEach(async (to, from) => {
    const commonStore = useCommonStore()
    await commonStore.setLayoutRouteIsLoading(false)
    await commonStore.setPageGlobalIsLoading(false)
    NProgress.done()
})
export default router
